module.exports = __webpack_public_path__ + "media/images/person-a2c5640d739ece2709712c14731e1b61.png";